export const educationConstants = {
    START: 'education:start',
    STOP: 'education:stop',
    EDUCATION: 'education:education',
    ADD: 'education:add',
    UPDATE: 'education:update',
    REMOVE: 'education:delete',
    CLEAR: 'education:clear',
};
